import { render, staticRenderFns } from "./AtendimentoItemDialog.vue?vue&type=template&id=537c728f"
import script from "./AtendimentoItemDialog.vue?vue&type=script&lang=js"
export * from "./AtendimentoItemDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports